module.exports = __webpack_public_path__ + "img/fundo_rodape.4d01fe10.png";